var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M23.715 12.224c0-.983-.08-1.7-.253-2.444H12.234v4.438h6.59c-.132 1.102-.85 2.763-2.444 3.88l-.022.148 3.55 2.75.246.025c2.259-2.086 3.56-5.156 3.56-8.797Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M12.234 23.918c3.229 0 5.94-1.063 7.92-2.897l-3.774-2.923c-1.01.704-2.365 1.195-4.146 1.195-3.162 0-5.846-2.086-6.803-4.969l-.14.012-3.692 2.857-.048.134c1.966 3.906 6.006 6.59 10.683 6.59Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M5.429 14.324a7.362 7.362 0 0 1-.399-2.365c0-.824.146-1.621.386-2.365l-.007-.159-3.738-2.903-.122.059a11.97 11.97 0 0 0-1.276 5.368c0 1.927.466 3.747 1.276 5.368l3.88-3.003Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB4335",
  d: "M12.234 4.624c2.245 0 3.76.97 4.624 1.78l3.375-3.295C18.16 1.183 15.463 0 12.234 0 7.557 0 3.517 2.684 1.551 6.59l3.866 3.004c.97-2.884 3.655-4.97 6.817-4.97Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgGoogleIcon as ReactComponent };
export default __webpack_public_path__ + "8deed1224bc33fce0459cd97e349a1e9.svg";